export const BIZ = {
  name: "DST New Braunfels",
  full: "Dynamic Sports Training",
  owner: "Steve Treviño",
  founder: "Lee Fiocchi",
  phone: "830-832-9898",
  phoneHref: "tel:+18308329898",
  email: "Dk@dynamicsportstraining.com",
  address1: "6700 I-35 N Frontage Rd, Suite 106",
  address2: "New Braunfels, TX 78130",
  hours: "3:00 PM – 8:00 PM",
  instagram: "https://www.instagram.com/dst_newbraunfels/",
  instagramHandle: "@dst_newbraunfels",
  facebook: "https://www.facebook.com/p/DST-New-Braunfels-61588363448177/",
  maps: "https://www.google.com/maps/search/?api=1&query=6700+I-35+N+Frontage+Rd+Suite+106+New+Braunfels+TX+78130",
  // Swift booking software.
  bookUrl: "https://book.runswiftapp.com/facilities/dst",
};

export const LOGO = "/brand/dst-logo.png";

export const MISSION =
  "We align the mind and body to achieve athletic mastery while maximizing every athlete's genetic potential.";

export const MOTTO =
  "We create an environment that empowers athletes, embodies commitment through action, fosters communication through continued education, and pursues unprecedented achievement as a team.";

export const IMG = {
  hero: "/brand/facility-gym.webp",
  facilityGym: "/brand/facility-gym.webp",
  facilityLobby: "/brand/facility-lobby.webp",
  facilityCages: "/brand/facility-3.webp",
  facilityFloor: "/brand/facility-4.webp",
  facilityTunnels: "/brand/facility-5.webp",
  heroAlt: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  batter: "https://images.unsplash.com/photo-1530143651579-c7f12d67ae3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  batter2: "https://images.unsplash.com/photo-1624375812928-106472d9ddb9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  pitcher: "https://images.unsplash.com/photo-1489460427746-b6296f4bc3f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  pitcherSunset: "https://images.unsplash.com/photo-1524849793792-21ff7d209495?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  pitcherField: "https://images.unsplash.com/photo-1513879392062-82c9a1d1c614?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  lifting: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  sprint: "https://images.unsplash.com/photo-1526676317768-d9b14f15615a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  running: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  stadiumRun: "https://images.unsplash.com/photo-1502904550040-7534597429ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  batField: "https://images.unsplash.com/photo-1654094706120-be054b9ef237?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const FEATURES = [
  { icon: "Trophy", title: "Elite Coaching", text: "Coaching built on decades of competitive experience — every rep, cue, and correction is intentional." },
  { icon: "Activity", title: "Sports Performance", text: "Speed, strength, mobility, and power programming engineered for measurable, on-field results." },
  { icon: "Target", title: "Baseball & Softball", text: "Hitting and throwing mechanics broken down frame by frame and rebuilt for the next level — for baseball and softball players alike." },
  { icon: "ClipboardCheck", title: "Accountability", text: "We hold athletes to a standard. Show up, work hard, and own the process — every single session." },
  { icon: "Users", title: "Group Training", text: "Our specialty — competitive small-group sessions that build accountability and raise every athlete's ceiling. Private one-on-ones available too." },
  { icon: "TrendingUp", title: "Results Driven", text: "We track progress relentlessly. If it isn't making you a better competitor, we don't do it." },
];

export const PROGRAMS = [
  {
    slug: "group-training",
    title: "Group Training",
    tag: "Our Specialty · Team · Competition",
    img: "stadiumRun",
    featured: true,
    short: "Our signature program. Train shoulder-to-shoulder with driven athletes in a competitive, high-energy environment where accountability is built in and everyone's ceiling rises together.",
    long: "Group training is what we do best. Small-group sessions blend individualized coaching with the accountability, energy, and iron-sharpens-iron culture that develops real competitors — faster, and with a team around you every rep. It's the best value and the best environment we offer, and most athletes make their biggest jumps here.",
  },
  {
    slug: "sports-performance",
    title: "Sports Performance",
    tag: "Speed · Strength · Power",
    img: "sprint",
    short: "Build a faster, stronger, more explosive athlete with programming that translates directly to competition.",
    long: "Our sports performance track develops the physical engine behind elite play — acceleration, top-end speed, change of direction, strength, and durability. Every block is periodized to your season and sport.",
  },
  {
    slug: "baseball-instruction",
    title: "Baseball & Softball Instruction",
    tag: "Mechanics · IQ · Reps",
    img: "batter",
    short: "Sport-specific instruction that sharpens mechanics, game IQ, and the mental side of the game — for baseball and softball players alike.",
    long: "From swing path to arm care, our baseball and softball instruction is grounded in modern movement science. We break the game down to fundamentals, then rebuild them into repeatable, high-level skills.",
  },
  {
    slug: "private-training",
    title: "Private Training",
    tag: "1-on-1 · Also Available",
    img: "lifting",
    short: "Prefer individual attention? Private one-on-one coaching is available for athletes who want a fully personalized plan — a great complement to group sessions.",
    long: "Private training offers undivided, one-on-one attention built entirely around a single athlete's goals. We recommend it alongside group training for athletes who want extra, focused reps — the best of both worlds.",
  },
];

export const DIFFERENCE = [
  { n: "01", title: "Discipline", text: "Elite performance is built in the unseen hours. We instill habits that hold up when no one is watching." },
  { n: "02", title: "Commitment", text: "We embody commitment through action — showing up, doing the work, and finishing what we start." },
  { n: "03", title: "Mindset", text: "We train the mind like a muscle. Confidence, focus, and resilience are coached, not left to chance." },
  { n: "04", title: "Communication", text: "We foster communication through continued education — athletes understand the why behind every rep." },
  { n: "05", title: "Consistency", text: "Greatness is a byproduct of showing up daily. We build systems that make progress inevitable." },
  { n: "06", title: "Leadership", text: "We develop competitors who lead — on the field, in the classroom, and in life." },
];

export const TEAM = [
  {
    name: "Mary Stephens",
    role: "General Manager & Softball Director",
    tagline: "Developing Hitters. Building Confident Athletes.",
    img: "/brand/mary-stephens.png",
    intro: [
      "Coach Mary Stephens brings a lifetime of softball experience to DST New Braunfels as a former standout high school and collegiate athlete, college coach, and hitting instructor. Her background combines years of playing at a high level with six seasons of collegiate coaching experience and a passion for developing the next generation of softball players.",
      "After years in the college game, Mary discovered that her greatest passion is working directly with young athletes—helping them develop their skills, understand the game, and grow in confidence both on and off the field.",
    ],
    sections: [
      {
        title: "Playing Background",
        intro: [
          "Mary graduated from Wylie High School, where she was a four-year varsity letter winner and established herself as one of the area's standout softball players.",
          "Her high school accomplishments earned her a place in the Wylie Hall of Honor, including recognition for setting the DFW home run record during her playing career.",
          "Following high school, Mary continued her softball career at Missouri State University, competing for the Bears from 2013–2017.",
          "Her experience as a player helped build the foundation for the hitting philosophy and coaching style she continues to develop today.",
        ],
      },
      {
        title: "Collegiate Coaching Experience",
        intro: [
          "After graduating from Missouri State, Mary spent six seasons working with multiple collegiate softball programs. Each stop gave her the opportunity to learn from different coaches, philosophies, and offensive systems while continuing to expand her knowledge of hitting and player development.",
          "Her collegiate coaching experience includes:",
        ],
        list: [
          "Texas Tech University — Volunteer Coach, 2018 & 2019",
          "Sam Houston State University — Volunteer Coach, 2020",
          "Wichita State University — Volunteer Coach, 2022",
          "Northwestern State University — Hitting Coach, 2023",
        ],
        outro: [
          "Working within different college programs allowed Mary to study a variety of hitting techniques and approaches rather than relying on one specific style of instruction.",
        ],
      },
      {
        title: "Coaching Philosophy",
        intro: [
          "Mary believes there is no single swing that works for every athlete. Her goal is to help players understand their own movement, develop strong fundamentals, and find an approach that allows them to become confident and successful hitters.",
          "While her background includes years of collegiate softball, Mary's passion ultimately led her back to working with younger athletes. She enjoys being part of the developmental process and helping players build a foundation they can carry with them as they advance through the game.",
          "At DST New Braunfels, Mary focuses on creating an environment where athletes can work hard, learn, make adjustments, and continue progressing without being afraid to fail.",
        ],
      },
    ],
    highlights: [
      "Four-year varsity softball letter winner at Wylie High School",
      "Member of the Wylie Hall of Honor",
      "Former DFW home run record holder",
      "Played NCAA Division I softball at Missouri State University (2013–2017)",
      "Six seasons of collegiate coaching experience",
      "Coaching experience at Texas Tech, Sam Houston State, Wichita State, and Northwestern State",
      "Former collegiate hitting coach",
      "Years of experience providing private hitting instruction and developing youth softball players",
      "Softball Coach & Hitting Instructor at DST New Braunfels",
    ],
  },
  {
    name: "Dennis \u201cDK\u201d Koenck",
    role: "Strength Coach & Personal Trainer",
    tagline: "Building Stronger Athletes. Developing Better People.",
    img: "/brand/dk-koenck.png",
    imgPos: "center 22%",
    intro: [
      "Dennis \u201cDK\u201d Koenck is a Houston-area strength coach and personal trainer with more than nine years of training experience. Throughout his career, Dennis has worked with athletes across a wide range of competitive levels, including MLB, UFC, NFL, collegiate, high school, and youth athletes.",
      "His approach to training goes beyond athletic performance. Dennis is passionate about helping athletes and individuals from all walks of life become stronger, healthier, more confident versions of themselves—both on and off the field.",
    ],
    sections: [
      {
        title: "Strength & Performance Experience",
        intro: [
          "Dennis has spent years developing and managing strength and conditioning programs designed around the individual needs of each athlete.",
          "From 2020–2021, he served as Director of Strength & Conditioning Operations at Dynamic Sports Training, where he helped lead the expansion of DST while working closely with athletes and coaches. His responsibilities included managing training programs and workloads for athletes ranging from youth competitors to professionals, as well as overseeing general fitness training.",
          "Dennis also served as Director of Pro Baseball Off-Season Training from 2017–2021. In this role, he worked with athletes to identify individual strengths, deficiencies, and performance goals before developing personalized programs designed to build more resilient, explosive, and prepared athletes.",
        ],
      },
      {
        title: "DK Performance / InKrease Athletics",
        intro: [
          "Since 2021, Dennis has continued his work through DK Performance / InKrease Athletics, providing personalized training programs, weekly coaching, and athlete check-ins.",
          "His training philosophy emphasizes individualized programming rather than a one-size-fits-all approach. By understanding each athlete's goals and needs, Dennis works to create training plans that promote long-term athletic development, overall wellness, and sustainable progress.",
        ],
      },
      {
        title: "Training Philosophy",
        intro: [
          "For Dennis, strength and conditioning is about more than lifting heavier weights or becoming faster. It's about creating habits, developing confidence, improving movement, and preparing athletes to perform when it matters.",
          "Whether working with a professional athlete, a young competitor, or someone simply looking to improve their overall fitness, Dennis brings the same goal to every session: help each person become a better version of themselves.",
        ],
      },
    ],
    highlights: [
      "9+ years of strength and performance training experience",
      "ISSA-SSC Certified Strength & Conditioning Specialist",
      "Experience training MLB, NFL, UFC, collegiate, high school, and youth athletes",
      "Former Director of Strength & Conditioning Operations at Dynamic Sports Training",
      "Former Director of Pro Baseball Off-Season Training",
      "Founder/Coach with DK Performance / InKrease Athletics",
      "Experienced in individualized programming, athlete assessments, strength development, explosiveness, and overall performance training",
    ],
  },
  {
    name: "Johnny Medina Jr.",
    role: "Hitting Coach & Baseball Director",
    tagline: "Experience at Every Level. Development for Every Athlete.",
    img: "/brand/johnny-medina.png",
    intro: [
      "Johnny Medina Jr. is a former collegiate and professional baseball player who brings a strong playing background, extensive training experience, and a player-first approach to DST New Braunfels.",
      "Throughout his career, Johnny competed at multiple levels of collegiate baseball, including NCAA Division III, NCAA Division II, JUCO, and NAIA, before continuing his career in professional independent baseball.",
      "His experience as both a player and trainer gives Johnny a unique perspective on what it takes to develop, compete, and continue progressing through each level of the game.",
    ],
    sections: [
      {
        title: "Playing Background",
        intro: ["Johnny's baseball journey has taken him through several levels of college and professional baseball, including:"],
        list: [
          "DeSales University — NCAA Division III",
          "Felician University — NCAA Division II",
          "Bergen Community College — JUCO",
          "Bluefield University — NAIA",
          "Alpine Cowboys — Professional Independent Baseball",
          "Eastside Diamond Hoppers — Professional Independent Baseball",
        ],
        outro: [
          "During his playing career, Johnny earned multiple honors and accomplishments, including Freshman of the Year, First Team All-Conference, and Second Team All-Conference recognition. He also finished his career with a batting average above .300, recorded multiple multi-home run games, and produced back-to-back seasons with double-digit home runs.",
        ],
      },
      {
        title: "Training & Player Development",
        intro: [
          "Johnny has worked with athletes ranging from youth players to professionals, including Major League, Minor League, collegiate, high school, and youth athletes.",
          "His training focuses on more than simply improving mechanics. Johnny works to help athletes develop the skills, confidence, work ethic, and mindset necessary to become better overall players.",
          "Every training session is built around purposeful development and helping each athlete understand how to get the most out of their abilities.",
        ],
      },
      {
        title: "Johnny's Mission",
        intro: [
          "Johnny's mission is simple: help players unlock their potential and reach their next level.",
          "Whether that next level means making a team, becoming a stronger hitter, preparing for high school or college baseball or softball, or pursuing opportunities beyond college, Johnny is committed to helping athletes continue moving forward.",
        ],
      },
    ],
    highlights: [
      "Former collegiate and professional baseball player",
      "Freshman of the Year",
      "First Team All-Conference",
      "Second Team All-Conference",
      "Career batting average above .300",
      "Multiple multi-home run games",
      "Back-to-back seasons with double-digit home runs",
      "Experience training MLB, Minor League, college, high school, and youth athletes",
      "Hitting Coach & Baseball Director at DST New Braunfels",
    ],
  },
  {
    name: "Ronnie Thames",
    role: "Baseball Director",
    tagline: "Developing Players. Building Opportunities.",
    img: "/brand/ronnie-thames.png",
    intro: [
      "Ronnie Thames brings decades of baseball experience to DST as a player, coach, recruiter, and athlete developer. His background spans youth, high school, collegiate, and professional baseball, giving him a well-rounded understanding of what athletes need to develop their game and prepare for the next level.",
      "A graduate of Humble High School, Ronnie continued his playing career at San Jacinto Junior College before attending Sam Houston State University, where he competed in both football and baseball.",
    ],
    sections: [
      {
        title: "Coaching & Player Development Experience",
        intro: [
          "Ronnie's coaching career has been centered around developing athletes while helping them find opportunities to continue their careers at the collegiate and professional levels.",
          "At Grayson Junior College, Ronnie was part of back-to-back NJCAA Division I National Championship teams in 1999 and 2000. In 2001, he began coaching select baseball with the Columbia Angels, where he played a major role in recruiting and college placement.",
          "In 2017, Ronnie became the High School Director for Marucci Elite Texas – Houston, overseeing the development of high school athletes while continuing his work in recruiting and college placement.",
          "After moving to Wimberley in 2021, Ronnie brought his experience and passion for player development to Central Texas and joined DST as Baseball Director.",
        ],
      },
      {
        title: "Ronnie's Approach",
        intro: [
          "Ronnie believes player development goes beyond simply taking swings or throwing baseballs. His goal is to help athletes understand the game, develop strong fundamentals, train with purpose, and build the skills and confidence needed to compete at a higher level.",
          "Whether an athlete is just beginning their baseball journey or preparing for high school, college, or beyond, Ronnie brings years of experience and a commitment to helping each player continue to grow.",
        ],
      },
    ],
    highlights: [
      "2\u00d7 NJCAA Division I National Champion — 1999 & 2000",
      "Former Marucci Elite Texas – Houston High School Director",
      "Extensive experience in recruiting and college placement",
      "Decades of baseball coaching and player-development experience",
      "Experience working with youth, high school, collegiate, and professional athletes",
      "Baseball Director at DST",
    ],
  },
];

export const TESTIMONIALS = [
  { name: "Parent of a HS Catcher", role: "New Braunfels, TX", quote: "The difference in my son's confidence and mechanics after a few months at DST is night and day. This is real coaching — they treat him like an individual, not a number.", rating: 5 },
  { name: "College Baseball Athlete", role: "Division I Commit", quote: "DST rebuilt my swing and my mindset. The accountability here is unlike anywhere I've trained. They expect your best every single day, and it shows on the field.", rating: 5 },
  { name: "Youth Softball Parent", role: "Comal County", quote: "Steve and the team genuinely care. My daughter actually looks forward to training. She's faster, stronger, and holds herself to a higher standard now.", rating: 5 },
  { name: "High School Pitcher", role: "Varsity Starter", quote: "The arm care and velocity work added real gas to my fastball, but the mental side is what set me apart this season. Best decision I've made as an athlete.", rating: 5 },
];

export const FAQ = [
  { q: "What ages do you train?", a: "We train athletes ages 10 to 35 — from youth and high school players developing their foundation, to college and competitive athletes chasing the next level." },
  { q: "How do I book a session?", a: "Tap any 'Book Now' button to book online instantly through our Swift booking system, or call us at 830-832-9898. Swift handles your scheduling, availability, payments, and confirmations in one place." },
  { q: "Do you offer private training?", a: "Group training is our specialty. Our small-group sessions deliver the competition, energy, and accountability that develop athletes the fastest — and they're our best value. We also keep limited availability for private one-on-one training when an athlete wants focused, individual attention." },
  { q: "What should I bring to my first session?", a: "Come in athletic clothing and training shoes with water. For baseball and softball sessions, bring your glove, bat, and cleats if you have them. We'll handle the rest." },
  { q: "How long are sessions?", a: "Most sessions run 60 minutes. Private performance training and group blocks are structured around each athlete's needs, goals, and training age." },
  { q: "Where are you located?", a: "We're at 6700 I-35 N Frontage Rd, Suite 106, New Braunfels, TX 78130. Training hours are 3:00 PM to 8:00 PM, with private training available by appointment." },
];

export const GALLERY = [
  { img: "facilityGym", label: "Strength & Turf" },
  { img: "facilityTunnels", label: "Batting Cages" },
  { img: "facilityFloor", label: "Training Floor" },
  { img: "facilityCages", label: "Cage Tunnels" },
  { img: "facilityLobby", label: "Player Wall" },
  { img: "batter", label: "Hitting" },
];

export const FACILITY_ITEMS = [
  { img: "facilityGym", label: "Performance Floor", caption: "Turf-lined strength & speed floor with premium racks, sleds, and the VelociRaptor curved treadmill." },
  { img: "facilityTunnels", label: "Indoor Batting Cages", caption: "Full-length netted cages with mounded turf, HitTrax data tracking, and dedicated instruction stations." },
  { img: "facilityFloor", label: "Strength & Conditioning", caption: "Open training bays with functional racks, medicine balls, and space engineered for explosive movement." },
  { img: "facilityCages", label: "Cage & Seating Area", caption: "Climate-controlled cage tunnels with stadium seating so parents can watch every rep." },
  { img: "facilityLobby", label: "Front Desk & Pro Wall", caption: "A welcoming check-in area anchored by our signed MLB jersey wall — DST alumni and pros." },
];

export const FACILITY_FEATURES = [
  { icon: "Building2", title: "Brand-New Facility", text: "A modern, purpose-built training environment — clean, organized, and dialed in for serious athletes." },
  { icon: "Target", title: "Indoor Batting Cages", text: "Full-length netted tunnels for year-round hitting and live reps, rain or shine." },
  { icon: "Cpu", title: "HitTrax Technology", text: "Data-driven swing tracking that turns every session into measurable, real feedback." },
  { icon: "Dumbbell", title: "Elite Strength Floor", text: "Premium racks, turf, and performance equipment built for speed, power, and durability." },
  { icon: "Snowflake", title: "Climate Controlled", text: "Comfortable, temperature-managed bays so athletes train hard every day of the year." },
  { icon: "Users", title: "Spectator Seating", text: "Stadium seating throughout so parents and teammates can watch the work up close." },
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/facilities", label: "Facilities" },
  { to: "/team", label: "Team" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];
